module.exports = __webpack_public_path__ + "img/ru.227e2893.svg";